import types from './types';

import sessionTypes from '../session/types';

const defaultState = {};

const photoSeriesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.LOAD_PHOTO_SERIES_SUCCESS: {
      const {
        photoSeriesId,
        data,
      } = action.payload;

      return {
        ...state,
        photoSeries: {
          ...state.photoSeries,
          [photoSeriesId]: data,
        },
      };
    }
    case types.LOAD_PHOTO_SERIES_REPAIR_ESTIMATIONS_SUCCESS: {
      const {
        photoSeriesId,
        data,
      } = action.payload;

      return {
        ...state,
        photoSeries: {
          ...state.photoSeries,
          [photoSeriesId]: {
            ...state.photoSeries[photoSeriesId],
            repairEstimations: data
          }
        }
      };
    }
    case types.LOAD_PHOTO_SERIES_DAMAGE_SUMMARY_SUCCESS: {
      const {
        photoSeriesId,
        data,
      } = action.payload;

      return {
        ...state,
        photoSeries: {
          ...state.photoSeries,
          [photoSeriesId]: {
            ...state.photoSeries[photoSeriesId],
            damages: data
          }
        }
      };
    }
    case types.LOAD_PHOTO_SERIES_REPORT_STATUS_SUCCESS: {
      const {
        photoSeriesId,
        data,
      } = action.payload;

      return {
        ...state,
        photoSeries: {
          ...state.photoSeries,
          [photoSeriesId]: {
            ...state.photoSeries[photoSeriesId],
            reportStatus: {
              ...state.photoSeries[photoSeriesId].reportStatus,
              ...data
            }
          }
        }
      };
    }
    case types.UPDATE_REPAIR_ESTIMATION_PRODUCT_INFO_SUCCESS: {
      const {
        photoSeriesId,
        bodyPart,
        productInfo,
      } = action.payload;

      const photoSeries = state.photoSeries?.[photoSeriesId] ?? {};
      const existingRepairEstimations = Array.isArray(photoSeries.repairEstimations)
        ? photoSeries.repairEstimations
        : [];

      const hasExistingRepairEstimation = existingRepairEstimations
        .some((repairEstimation) => repairEstimation.bodyPart === bodyPart);

      const updatedRepairEstimations = hasExistingRepairEstimation
        ? existingRepairEstimations.map((repairEstimation) => (
          repairEstimation.bodyPart === bodyPart
            ? { ...repairEstimation, productInfo }
            : repairEstimation
        ))
        : [
          ...existingRepairEstimations,
          {
            bodyPart,
            repairDecision: null,
            confidence: null,
            productInfo
          }
        ];

      return {
        ...state,
        photoSeries: {
          ...state.photoSeries,
          [photoSeriesId]: {
            ...photoSeries,
            repairEstimations: updatedRepairEstimations
          }
        }
      };
    }
    case types.UPDATE_REPAIR_DECISION_SUCCESS: {
      const {
        photoSeriesId,
        data,
      } = action.payload;

      return {
        ...state,
        photoSeries: {
          ...state.photoSeries,
          [photoSeriesId]: {
            ...state.photoSeries[photoSeriesId],
            ...data,
          }
        }
      };
    }
    case sessionTypes.LOG_OUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default photoSeriesReducer;
